import React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { yupResolver } from '@hookform/resolvers/yup';
import yup from 'shared/yubGlobal';
import { useOAuthMutation, useLazyUserQuery } from 'services/auth';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Typography,
  Wrapper,
  Container,
  Box,
  FormControl,
  Input,
  Link
} from 'components';
import RouteName from 'config/routes';

function Login() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [authLogin, { isLoading }] = useOAuthMutation();
  const [getUser] = useLazyUserQuery()

  const schema = yup.object().shape({
    email: yup
      .string()
      .required(t('validate:requiredEmail'))
      .max(255, t('validate:oversizedEmail'))
      .email(t('validate:invalidEmail')),
    password: yup
      .string()
      .required(t('validate:requiredPassword'))
  });
  
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(schema),
  });

  const email = watch('email', '');
  const password = watch('password', '');

  const onSubmit = (data) => {
    authLogin(data).unwrap().then((payload) => {
      localStorage.setItem('userToken', payload.access_token);
      getUser().unwrap().then(res => {
        const user = res.user;
        if (user?.is_first_login) {
          return navigate(RouteName.guide);
        }
        navigate(RouteName.home);
      })
    }).catch(() => {});
  }

  return (
    <Wrapper>
      <Container bottom={80}>
        <Box pt={48} pb={48}>
          <Typography variant="h2">{t('login:title')}</Typography>
        </Box>
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormControl error={errors.email}>
            <Input
              {...register('email')}
              placeholder={t('login:email')}
            />
          </FormControl>
          <FormControl error={errors.password}>
            <Input
              {...register('password')}
              type="password"
              placeholder={t('login:password')}
            />
          </FormControl>
          <Box mt={-12} pr={20} textAlign="right">
            <Link to={RouteName.forgotPassword} underline="none">
              {t('login:forgotPassword')}
            </Link>
          </Box>
          <Box mt={48}>
            <Button
              disabled={!email || !password || isLoading}
              type="submit"
            >{t('login:buttonTitle:signIn')}</Button>
          </Box>
        </form>
        <Box pt={24} textAlign="center">
          <Link to={RouteName.login} underline="always">
            {t('login:bySMS')}
          </Link>
        </Box>
      </Container>
    </Wrapper>
  )

}

export default Login;
